import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule  } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ThemeConfig } from './theme.config';
import { JsonSchemaFormModule, Bootstrap4FrameworkModule } from 'angular2-json-schema-form';
import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule, bootstrap4Mode } from 'ngx-modialog/plugins/bootstrap';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

 
//run the plugin to work with version 4 of bootstrap
bootstrap4Mode();

/***** Components *****/
 
/***** Services *****/
import { ThemeSpinnerService } from './services/themeSpinner.service';
import { AlertService } from './services/alert.service';
import { RequestService } from './services/request.service';
import { ChannelService } from './services/channel.service';
import { LanguageService } from './services/language.service';

const COMPONENTS = [ 
	
 
];

const DIRECTIVES = [];

const PIPES = [];

const SERVICES = [

	ThemeSpinnerService,
	AlertService,
	RequestService
];

const VALIDATORS = [];

export const jsonSchemaFormModuleForRoot = JsonSchemaFormModule.forRoot(

	Bootstrap4FrameworkModule

);

@NgModule( {

	declarations: [

		...COMPONENTS,
		...DIRECTIVES,
		...PIPES

	],

	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		Bootstrap4FrameworkModule,
		jsonSchemaFormModuleForRoot,
		ModalModule.forRoot(),
		BootstrapModalModule,

		MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule,
  	],

	entryComponents: [],

	exports: [

		...COMPONENTS,
		...DIRECTIVES,
		...PIPES

	],

	providers: [
		ChannelService,
		LanguageService
	]

} )
export class ThemeModule {

	static forRoot(): ModuleWithProviders {

		return <ModuleWithProviders>{

			ngModule: ThemeModule,

			providers: [

				ThemeConfig,

				...VALIDATORS,
				...SERVICES

			]

		};

	}

}



// WEBPACK FOOTER //
// ./src/app/theme/theme.module.ts